<app-template>

<p>Server status: <span class="success">Works</span></p>
<p>Server time: <span class="success">{{date}}</span></p>


</app-template>
